import { DealSheetFormValues } from './types';
import { Country } from '@trnsact/trnsact-shared-types';

export const dealSheetInitialFormValues: DealSheetFormValues = {
  name: '',
  description: '',

  taxes: [],
  charges: [],

  customer: { type: [], paymentType: [] },
  equipment: { type: [], make: [], year: [], model: [] },
  address: { zip: [], state: [], county: [], country: Country.Us, city: [], postalCode: [], province: [] },
};
